import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import _ from 'lodash';
import { Container, Content } from 'components/basics';
import EmotionsBlock from './EmotionsBlock';
import TitleEmotionsBlock from './TitleEmotionsBlock';
import { breakpoint } from 'utils/mediaQueries';
import { emotions } from 'config/emotions';
import BlockButtonTestQemotion from 'components/BlockTestQemotion/BlockButtonTestQemotion';

const ContentBlock = styled(Grid)`
  padding: 4rem 0;
  width: 100%;
  max-width: 1200px;
  position: relative;
  ${breakpoint.down('sm')`
padding-top: 2rem;padding-bottom: 0;`}
`;
const ContentTitle = styled(Grid)`
  padding-top: 4rem;
  ${breakpoint.down('md')`
  padding-top: 0;`}
  ${Content};
`;

const EmotionsBlocks = ({ data: { title, images }, lang }) => {
  const imagesEmotions = images;
  return (
    <Container>
      <ContentTitle container spacing={40} justify="center">
        <TitleEmotionsBlock data={title} lang={lang} />
      </ContentTitle>
      <ContentBlock container justify="center">
        {emotions.map((block, index) => (
          <EmotionsBlock
            key={`EmotionsBlock${index}`}
            data={block}
            lang={lang}
            image={_.find(imagesEmotions, function(image) {
              return image.base === block.base;
            })}
          />
        ))}
      </ContentBlock>
      <BlockButtonTestQemotion lang={lang} justifyContent={'center'} />
    </Container>
  );
};

export default EmotionsBlocks;
